import { Col, Container, Row } from "reactstrap";
import BecomeMember from "./BecomeMember";
import SimplePricingCard from "./SimplePricingCard";
import { ECommerce, Pricing } from "../../../../constants";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";


// This component is a container for the Pricing page. It displays pricing-related information including membership and pricing cards.
const PricingContainer = () => {

  return (
    <>
      <Breadcrumbs mainTitle={Pricing} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <BecomeMember />
            <SimplePricingCard />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PricingContainer;